import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch";

const style = {
  ...customCheckboxRadioSwitch,
  pageContainer: {
    padding: "0 5%"
  },
  section: {
    marginTop: 32
  },
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  imageSection: {
    alignItems: 'flex-start',
    minHeight: 150,
    marginTop: 24,
    display: 'block',
    "@media (min-width: 768px)": {
      display: 'flex',
    },
  },
  categorySection: {
    display: 'block',

    "@media (min-width: 768px)": {
      display: 'flex',
      alignItems: 'center'
    }
  },
  categoryDD: {
    marginBottom: 8,
    '&:before, &:after': {
      display: 'none'
    },
    '& svg': {
      display: 'none'
    },
    "@media (min-width: 768px)": {
      marginBottom: 0,
    }
  },
  select: {
    border: '1px solid #2DAAF2',
    borderRadius: 8,
    padding: '8px 16px',
    marginRight: 8,
    color: '#2DAAF2',
    fontWeight: 400,
    '&:focus': {
      borderRadius: 8,
    },
    "@media (min-width: 768px)": {
      marginLeft: 8,
    }
  },
  maxChars: {
    fontSize: 12,
    textAlign: 'right'
  },
  ownerSection: {
    display: 'block',
    justifyContent: 'space-between',
    '@media (min-width:768px)': {
      display: 'flex',
    }
  },
  infoPhoneField: {
    margin: 0,
    color: '#2daaf2',
    fontWeight: 400,
    lineHeight: 0,
  },
  infoIconPhoneField: {
    width: 20,
    color: '#2daaf2',
    marginRight: 2,
  },
  contentBtns: {
    '& h3': {
      margin: 0
    },
    '& button': {
      width: '100%',
      '@media (min-width:768px)': {
        width: 'auto',
        float: 'right',
      }
    }
  },
  errorCategoryField: {
    fontSize: '0.75rem',
    color: '#f44336',
    margin: 0,
  },
};

export default style;